import { ChatMessage, ChatMessageTypeEnum } from 'lib-trend-core';
import { ChatDialogService } from '../../services/chat-dialog.service';
import { ChatImageViewerData, ChatImageViewerDialogComponent, ChatImageViewerItem } from './chat-image-viewer-dialog.component';

/** The gallery of a message list: its image attachments, in list order (deleted ones excluded). */
export function collectChatImages(messages: ReadonlyArray<ChatMessage & { deleted?: boolean }>): ChatImageViewerItem[] {
  return messages
    .filter((message) => message.type === ChatMessageTypeEnum.IMAGE && !!message.fileUrl && !message.deleted)
    .map((message) => ({
      id: message._id || message.clientMessageId || '',
      url: message.fileUrl as string,
      name: message.fileName,
    }));
}

/**
 * Opens the image viewer on `currentId` — SPEC-2026-07-internal-chat T-33 media cards
 * (DEV-2062). One full-viewport dialog on every surface: the backdrop paints the
 * darkness, the surface is a transparent stage (see the overlay classes in
 * chat-internal.scss). Focus lands on the dialog itself so ←/→ work at once, and
 * goes back to the thumbnail on close.
 */
export function openChatImageViewer(dialog: ChatDialogService, images: ChatImageViewerItem[], currentId: string): void {
  if (!images.length) return;
  const index = Math.max(0, images.findIndex((image) => image.id === currentId));
  const data: ChatImageViewerData = { images, index };
  dialog.open(ChatImageViewerDialogComponent, {
    data,
    width: '100vw',
    maxWidth: '100vw',
    height: '100dvh',
    maxHeight: '100dvh',
    panelClass: 'chat-image-viewer-panel',
    backdropClass: 'chat-image-viewer-backdrop',
    autoFocus: 'dialog',
    ariaLabel: images[index].name,
  });
}
